import { render, staticRenderFns } from "./not-goods.vue?vue&type=template&id=5f1baf50&scoped=true&"
import script from "./not-goods.vue?vue&type=script&lang=js&"
export * from "./not-goods.vue?vue&type=script&lang=js&"
import style0 from "./not-goods.vue?vue&type=style&index=0&id=5f1baf50&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1baf50",
  null
  
)

export default component.exports